module.exports = __webpack_public_path__ + "static/img/3-2.e6b1fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/3-2.png
// module id = QnoR
// module chunks = 1